import { render } from "./ApproveAppointmentModal.vue?vue&type=template&id=0cdc89e4"
import script from "./ApproveAppointmentModal.vue?vue&type=script&lang=js"
export * from "./ApproveAppointmentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__